/* Again — announcement countdown (sections/again-announcement-countdown.liquid).
   Counts only to a real deadline the section passes in:
     data-end       epoch seconds of the offer end (set by the merchant), or
     data-cutoff    daily dispatch cutoff "HH:MM" in data-tz (IANA), merchant-confirmed, or
     data-midnight  daily countdown to 00:00 in the visitor's local time (rolls to the next day).
   No deadline, a past deadline, or an unreadable setting -> the timer stays hidden and the bar
   shows its message alone. Nothing is stored per visitor and nothing ever restarts at zero. */
(function () {
  var root = document.querySelector('[data-ag-countdown]');
  if (!root) return;
  var timer = root.querySelector('.ag-cd__timer');
  if (!timer) return;

  var el = {
    d: root.querySelector('[data-d]'),
    h: root.querySelector('[data-h]'),
    m: root.querySelector('[data-m]'),
    s: root.querySelector('[data-s]'),
    days: root.querySelector('[data-unit="days"]'),
  };
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  function pad(n) { return String(n).padStart(2, '0'); }

  /* seconds left until today's cutoff in the warehouse time zone, or 0 when past / not a dispatch day */
  function cutoffLeft() {
    var hm = /^(\d{1,2}):(\d{2})$/.exec(root.dataset.cutoff || '');
    if (!hm) return 0;
    var parts;
    try {
      parts = new Intl.DateTimeFormat('en-US', {
        timeZone: root.dataset.tz, hour12: false, weekday: 'short',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
      }).formatToParts(new Date());
    } catch (e) { return 0; }
    var p = {};
    parts.forEach(function (x) { p[x.type] = x.value; });
    var day = DAYS.indexOf(p.weekday);
    if (root.dataset.weekdaysOnly === 'true' && (day === 0 || day === 6)) return 0;
    var now = (parseInt(p.hour, 10) % 24) * 3600 + parseInt(p.minute, 10) * 60 + parseInt(p.second, 10);
    var cut = parseInt(hm[1], 10) * 3600 + parseInt(hm[2], 10) * 60;
    return Math.max(0, cut - now);
  }

  function left() {
    if (root.dataset.end) {
      var end = parseInt(root.dataset.end, 10);
      if (!end) return 0;
      return Math.max(0, Math.floor(end - Date.now() / 1000));
    }
    if (root.dataset.cutoff) return cutoffLeft();
    if (root.dataset.midnight) {
      var n = new Date();
      var mid = new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1, 0, 0, 0);
      return Math.max(1, Math.round((mid - n) / 1000));
    }
    return 0;
  }

  var tick;
  function render() {
    var t = left();
    if (t <= 0) {
      /* deadline reached or absent: message only, never a restart */
      timer.hidden = true;
      root.classList.remove('ag-cd--timed');
      if (tick) clearInterval(tick);
      return false;
    }
    var d = Math.floor(t / 86400);
    var h = Math.floor((t % 86400) / 3600);
    var m = Math.floor((t % 3600) / 60);
    var s = t % 60;
    el.days.hidden = d < 1;
    el.d.textContent = pad(d);
    el.h.textContent = pad(h);
    el.m.textContent = pad(m);
    el.s.textContent = pad(s);
    timer.hidden = false;
    root.classList.add('ag-cd--timed');
    return true;
  }

  if (render()) tick = setInterval(render, 1000);
})();
